import React, { useEffect, useState } from 'react';
import './styles.less';
/*
    id
    label
    text
    name
    multiple
    fileSelect
 */

import axios from 'axios';
import apiUrl, { UserFileDict } from '../../utils/settings';
import { getToken, getTokenHeader } from '../../screen/auth/action';
import ConfirmModal from '../confirmModal';
import notification from 'antd/es/notification';
import Spin from 'antd/es/spin';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { GetMeAction, getProfilePicture } from '../../v2/Onboarding/auth/action';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UserFileUploadUrl = () => {
  return apiUrl + '/users-file/upload-users-id-proof';
};
const UserFileUploadNow = async (userId, fileType, formData) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${UserFileUploadUrl()}?user_id=${userId}&file_type=${fileType}`,
        formData,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

const FileInput = (props) => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const [file, setFile] = useState();
  const dispatch = useDispatch();

  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  const getUserPic = async () => {
    const { error: userError, data: loggedInUser } = await GetMeAction();
    const url = getProfilePicture(loggedInUser?.profile_picture_details);

    if (typeof url !== 'object') {
      dispatch({
        type: 'SET_USER',
        data: { ...loginUser, profile_image: url },
      });
    }
  };
  const onClickHandler = (event) => {
    event.preventDefault();
    document.getElementById(props.id).click();
    console.log(props);
  };

  const onChangeHandler = (event) => {
    const maxFileSize = 10 * 1024 * 1024; // 10 MB in bytes
    const selectedFiles = event.target.files;

    if (props.multiple) {
      const invalidFiles = Array.from(selectedFiles).filter(
        (file) => file.size > maxFileSize,
      );

      if (invalidFiles.length > 0) {
        toast.error(
          `Some files exceed the maximum size of 10 MB. Please upload smaller files.`,
        );
        return;
      }
      setFile(selectedFiles);
    } else {
      const selectedFile = selectedFiles[0];
      if (selectedFile.size > maxFileSize) {
        toast.error(
          'The file exceeds the maximum size of 10 MB. Please upload a smaller file.',
        );
        return;
      }
      setFile(selectedFile);
    }
    document.getElementById(props.id).value = '';
  };
  const executeUpload = async () => {
    if (!props.file_type) {
      notification.error({
        message: 'Error',
        description: t('notifications.missingFileMessage'),
      });
      return;
    }
    let formData = new FormData();
    formData.append('user_id', props.user_id);
    formData.append('file_type', props.file_type);
    formData.append('id_proof', file);
    setLoader(true);
    const { error: errorUp, message: messageUp } = await UserFileUploadNow(
      props.user_id,
      props.file_type,
      formData,
    );
    setLoader(false);
    if (errorUp) {
      toast.error(messageUp);
    } else {
      getUserPic();
      toast.success('Profile Picture uploaded successfully');
      if (props.refreshHandler) props.refreshHandler();
    }
  };
  // const onChangeHandler = (event) => {
  //   if (props.multiple) {
  //     setFile((prev) => event.target.files);
  //   } else {
  //     setFile((prev) => event.target.files[0]);
  //   }
  //   document.getElementById(props.id).value = '';
  // };
  useEffect(() => {
    if (file) {
      ConfirmModal(
        'Confirm Upload',
        'Are you sure you want to upload this file',
        executeUpload,
        () => {
          setFile(null);
        },
        'Yes',
        'No',
      );
    }
  }, [file]);

  return (
    <div className={'fileInput'}>
      <label htmlFor={props.id}>
        <Button
          variant='text'
          color='primary'
          component='span'
          onClick={onClickHandler}
        >
          {loader ? <Spin /> : props.text}
        </Button>
      </label>

      <input
        ref={props.inputRef}
        className={'input'}
        type={'file'}
        id={props.id}
        name={props.name}
        multiple={props.multiple}
        onChange={onChangeHandler}
        accept={props.accept || null}
      />
    </div>
  );
};

export default FileInput;
